<template>
  <div>
    <page-header title="Jobs" class="page-banner"></page-header>
    <div class="container">
      <content-loader v-if="$apollo.loading" title="Jobs" />
      <div v-else>
        <div
          class="row mb-3 align-items-sm-center d-flex justify-content-between"
        >
          <div class="col-sm-6">
            <h2 class="cs-textstyle-page-subtitle">Latest Jobs</h2>
          </div>
        </div>
        <div class="job-list">
          <div class="job" v-for="job in jobs" :key="job.id">
            <app-job-card :job="job" @click="onOpenJobDetails(job)" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ListRecentJobs from '@/newgql/ListRecentJobs.gql';
import PageHeader from '@/components/global/PageHeader';
import SearchBar from '@/components/global/SearchBar';
import ContentLoader from '@/components/global/ContentLoader';
import FilterByCity from '@/components/global/FilterByCity';
import AppJobCard from '@/components/jobs/JobCard';
export default {
  name: 'job-list',

  components: {
    PageHeader,
    SearchBar,
    ContentLoader,
    FilterByCity,
    AppJobCard
  },

  apollo: {
    jobs: ListRecentJobs
  },
  methods: {
    onOpenJobDetails(job) {
      this.$router.push({ name: 'JobDetail', params: { id: job.id } });
    }
  }
};
</script>

<style scoped lang="scss">
.container {
  text-align: left;
  margin-bottom: 60px;
}

img {
  width: 45px;
  height: 45px;
  border-radius: 50%;
}
.card-company {
  margin-top: 5px;
  margin-bottom: 0px;
}
.card-radius {
  border-radius: 10px;
}
.job-list {
  display: grid;
  grid-gap: 1rem;
  @include media-breakpoint-up(md) {
    grid-template-columns: repeat(2, 1fr);
  }
  @include media-breakpoint-up(lg) {
    grid-template-columns: repeat(3, 1fr);
  }
}
.job {
  cursor: pointer;
}
.card-button {
  position: absolute;
  bottom: 10px;
}
.card-body {
  padding-left: 0;
  padding-right: 0;
}
</style>
